import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    achievement: {
      width: '100%',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
    },
    nameContainer: {
      width: 'fit-content',
    },
    name: {
      width: 'fit-content',
      fontSize: 20,
      lineHeight: 1.17,
      fontWeight: 'bold',
      textAlign: 'right',
      display: 'block',
      marginBottom: 18,
      [media.tablet]: {
        width: 150,
        fontSize: 24,
        marginRight: 24,
        marginBottom: 0,
        wordBreak: 'normal',
        overflow: 'hidden',
      },
      [media.desktop]: {
        fontSize: 24,
        marginBottom: 0,
      },
    },
    resultsContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 10,
      [media.tablet]: {
        flexDirection: 'row',
      },
    },
    results: {
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      height: 'fit-content',
      [media.tablet]: {
        flexGrow: 1,
      },
    },
    icon: {
      height: 44,
      width: 44,
      borderRadius: 33,
      position: 'absolute',
      zIndex: 3,
      [media.tablet]: {
        height: 68,
        width: 68,
      },
      [media.desktop]: {
        height: 68,
        width: 68,
      },
    },
    progressBarContainer: {
      height: 33,
      marginLeft: 35,
      width: '100%',
      position: 'relative',
      background: palette.grey,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      [media.tablet]: {
        height: 49,
      },
      [media.desktop]: {
        height: 49,
      },
    },
    progressBar: {
      position: 'absolute',
      height: '100%',
      width: `${styles.showProgress ? styles.progress : 0}%`,
      backgroundColor: 'red',
      left: 0,
      transition: '1s',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
    },
    progressValueContainer: {
      position: 'absolute',
      height: '100%',
      width: `${styles.showProgress ? (styles.progress > 30 ? styles.progress : 100) : 0}%`,
      left: 0,
      transition: '1s',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    progressValue: {
      width: '100%',
      fontSize: 15,
      fontWeight: 'bold',
      zIndex: 2,
      textAlign: 'center',
      transition: 'opacity 1s ease-out',
      opacity: styles.showProgress ? 1 : 0,
      [media.tablet]: {
        fontSize: 24,
      },
      [media.desktop]: {
        fontSize: 24,
      },
    },
    description: {
      margin: 0,
      fontSize: 16,
      lineHeight: 1.25,
      [media.tablet]: {
        marginLeft: 174,
      },
    },
  });
};
